import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthFacade } from '@ecosure-suite/back-office/auth/data-access-auth';
import { environment } from '../environments/environment';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: `
    <ngx-loading-bar></ngx-loading-bar>
    <router-outlet></router-outlet>
    <es-count-down-timer
      *ngIf="(isAuthenticated$ | async)"
    ></es-count-down-timer>
    <toaster-container></toaster-container>
  `
})
export class AppComponent implements OnInit {
  isAuthenticated$ = this.authService.isAuthenticated$;

  constructor(
    translate: TranslateService,
    private authService: AuthFacade,
    private router: Router
  ) {
    translate.addLangs(environment.languages.map(language => language.code));
    translate.setDefaultLang(environment.defaultLanguage);

    const browserLang = translate.getBrowserLang();

    translate.use(
      browserLang.match(
        new RegExp(
          environment.languages.map(language => language.code).join('|')
        )
      )
        ? browserLang
        : environment.defaultLanguage
    );

    authService.hasValidAccessToken()
      ? authService.getUserDetails()
      : authService.logout();
  }

  ngOnInit() {
    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
